import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container flexSB">
        <div className="footer-section">
          <h4>eBB</h4>
          <p>O Conteúdo que Precisas</p>
        </div>
        <div className="footer-section">
          <h4>Links Úteis</h4>
          <ul>
            <li><a href="/">Início</a></li>
            <li><a href="/quem-somos">Quem Somos</a></li>
            <li><a href="/conteudo">Conteúdo</a></li>
            <li><a href="/contacto">Contacte-nos</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Redes Sociais</h4>
          <div className="social">
            <a href="#"><i className="fab fa-facebook-f icon"></i></a>
            <a href="#"><i className="fab fa-instagram icon"></i></a>
            <a href="#"><i className="fab fa-twitter icon"></i></a>
            <a href="#"><i className="fab fa-youtube icon"></i></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 eBB. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;